import React, {useEffect} from 'react';
import {RouterProvider} from 'react-router-dom';
import router from './router';
import 'video-react/dist/video-react.css';
import '@/style/App.scss';
import {ConfigProvider, message} from "antd";
import RechargeModal, {RechargeQrcodeModal, ShareBox} from "@/components/Recharge";
import {useStateControls} from "@/utils/viewHook";
import {ActInitShowLoginModal, ActInitShowRechargeModal, ActInitShowShare} from "@/store/action/control";
import {useDispatch} from "react-redux";
import {LoginByPhone} from "@/components/pages/index/loginByPhone";
import {clearUserTempMessage, getUserEquity, getUserTempMessage} from "@/api/auth";
import {
    ActInitUserVideoBalance,
    ActInitVipMonthV24_03_04EndTime,
    ActInitVipWeekV24_03_04EndTime
} from "@/store/action/user";
import {LocalStorageKey, LocalStorageManagement} from "@/libs/LocalStorage";
import {RouterEnum} from "@/libs/router";
import {gaAddPath} from "@/libs/ga";

function App() {
    const {
        isShowRecharge,
        isShowLoginModal,
        isShowShare,
    } = useStateControls();

    const dispatch = useDispatch();
    const setIsShowRecharge = (e: boolean) => {
        dispatch(ActInitShowRechargeModal(e));
    }

    const allFunc = async (path: RouterEnum) => {
        // if (!path) {
        //     router.navigate(RouterEnum.Index);
        //     return;
        // }
        if (path === RouterEnum.FSLoginHandler || path === RouterEnum.FSLogin) {
            return;
        }

        if (path !== RouterEnum.login && path !== RouterEnum.newsControl) {
            if (new LocalStorageManagement(LocalStorageKey.shareCodeRegisterUser).value) {
                message.success('注册成功,20次免费视频生成已到账', 10);
                new LocalStorageManagement(LocalStorageKey.shareCodeRegisterUser).remove();
            }
            getUserEquity().then((res) => {
                dispatch(ActInitUserVideoBalance(res.data.data.video_balance));
                dispatch(ActInitVipMonthV24_03_04EndTime(res.data.data.vip_month_v24_03_04_end_time || 0))
                dispatch(ActInitVipWeekV24_03_04EndTime(res.data.data.vip_week_v24_03_04_end_time || 0))
                new LocalStorageManagement(LocalStorageKey.shareCode).set(res.data.data.share_code);
                if (res.data.data?.has_temp_message) {
                    getUserTempMessage().then(async (res) => {
                        if (res.data.data.temp_message.length > 0) {
                            message.success(res.data.data.temp_message[0].message, 10);
                            await clearUserTempMessage();
                        }
                    }).catch(e => {
                        console.log(e);
                    })
                }
            }).catch(e => {
                console.log(e);
            })
        }
    }

    useEffect(() => {
        const url = new URL(window.location.href);
        const path = url.pathname;
        allFunc(path as RouterEnum);
        gaAddPath();
        router.subscribe(async (e) => {
            const url = new URL(window.location.href);
            const path = url.pathname;
            allFunc(path as RouterEnum);
            await gaAddPath();
        })
    }, []);


    return (
        <ConfigProvider theme={{
            token: {
                colorPrimary: 'black',
                borderRadius: 0,
            },
        }}>
            <div>
                {/*<RechargeModal isShow={isShowRecharge} setIsShow={setIsShowRecharge}/>*/}
                {/*{isShowLoginModal &&*/}
                {/*    <div onClick={() => {*/}
                {/*        dispatch(ActInitShowLoginModal(false));*/}
                {/*    }}*/}
                {/*         className={'fixed flex justify-center items-center w-full hover:cursor-pointer min-h-100vh h-100%'}*/}
                {/*         style={{background: 'rgba(0,0,0,0.6)', zIndex: '999'}}>*/}
                {/*        <LoginByPhone/>*/}
                {/*    </div>*/}
                {/*}*/}
                {/*{*/}
                {/*    isShowShare &&*/}
                {/*    <div*/}
                {/*        className={'fixed left-0 top-0 z-50 flex justify-center items-center hover:cursor-pointer w-full h-full'}*/}
                {/*        style={{*/}
                {/*            background: 'rgba(0,0,0,0.6)',*/}
                {/*        }} onClick={(e) => {*/}
                {/*        if (e.target !== e.currentTarget) return;*/}
                {/*        dispatch(ActInitShowShare(false))*/}
                {/*    }}>*/}

                {/*        <ShareBox setIsShowShare={() => {*/}
                {/*            dispatch(ActInitShowShare(false));*/}
                {/*        }}/>*/}
                {/*    </div>*/}
                {/*}*/}
                <RouterProvider router={router}/>
                {/*<RechargeQrcodeModal/>*/}
            </div>
        </ConfigProvider>
    )
}

export default App
